/*! Albatross (C) GrandPad, Inc */

import * as password_html from './password.html';
import Vue from 'vue';
import {ValidationUtilsMixin} from '../../shared/mixins/validation-utils-mixin';

export default Vue.extend({

	render: password_html.render,
	staticRenderFns: password_html.staticRenderFns,
	mixins: [ValidationUtilsMixin],

	components: {
		'gp-nav-buttons': () => import('../../shared/components/nav-buttons')
	},

	data: function ()
	{
		return {
			password: null as string | null
		};
	},

	watch: {
		password: {
			handler ()
			{
				//@ts-ignore validateForm is from the validation-utils-mixin
				this.validateForm(true);
			}
		}
	},

	methods: {
		onClickForgotPassword: function ()
		{
			this.$emit('forgot');
		},

		onClickBack: function ()
		{
			this.$emit('back');
		},

		onClickNext: function ()
		{
			if (this.password === null || this.password === '')
			{
				console.error('Missing password');
				return;
			}
			this.$emit('submitPassword', this.password);
		}
	}
});
